module.exports = __webpack_public_path__ + "static/img/site-4.6e87fb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/site-4.png
// module id = /17w
// module chunks = 0